import * as React from "react";
const SvgPlay = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, fill: "none", viewBox: "0 0 48 48", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M16 34l16.25-10L16 14v20z" }));
export default SvgPlay;
